// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretLeftSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M6.24807 7.16795C5.65434 7.56377 5.65434 8.43623 6.24808 8.83205L9.4453 10.9635C10.1099 11.4066 11 10.9302 11 10.1315L11 5.86852C11 5.06982 10.1099 4.59343 9.4453 5.03647L6.24807 7.16795Z" />
    </svg>
  );
};
